"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useDeviceMatch = void 0;
const react_1 = require("react");
const types_1 = require("./types");
const utils_1 = require("@10xlabs/utils");
const useDeviceMatch = () => {
    const [deviceMatch, setDeviceSize] = (0, react_1.useState)([types_1.EDeviceType.Mobile]);
    const deviceSizeMatch = () => {
        const deviceSize = [types_1.EDeviceType.Mobile];
        if (window.innerWidth >= Number(utils_1.SCREEN_SIZES_IN_PX.desktop)) {
            deviceSize.push(types_1.EDeviceType.Desktop);
        }
        if (window.innerWidth >= Number(utils_1.SCREEN_SIZES_IN_PX.laptop)) {
            deviceSize.push(types_1.EDeviceType.Laptop);
        }
        if (window.innerWidth >= Number(utils_1.SCREEN_SIZES_IN_PX.tablet)) {
            deviceSize.push(types_1.EDeviceType.Tablet);
        }
        return deviceSize;
    };
    const handleResize = () => {
        setDeviceSize(deviceSizeMatch());
    };
    (0, react_1.useEffect)(() => {
        setDeviceSize(deviceSizeMatch());
        window.addEventListener('resize', handleResize);
        return () => {
            window.removeEventListener('resize', handleResize);
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return deviceMatch;
};
exports.useDeviceMatch = useDeviceMatch;
//# sourceMappingURL=use-device-match.js.map